import strFunc from "@/lib/lyg/string";
import ListSimpleArea from "@/pcomponents/common/crud/list/list_simple";

function ListArea(props: any) {
  let myProps = {
    xColumnArr: {},
    infoArr: [],
    setInfoArr: (inData: any) => { },
    select_row_num_arr: [],
    set_select_row_num_arr: (inData: any) => { },
    ...props
  };
  let xColumnArr = myProps.xColumnArr;
  let infoArr = myProps.infoArr;
  let select_row_num_arr = myProps.select_row_num_arr;


  const get_td_render_tag = (inData: any) => {
    let opt_obj = {
      ...inData
    };
    let key=opt_obj.key;
    if (key == "row_view_money_in") {
      if (opt_obj.info.a_inout == "in" && opt_obj.info.a_money_type == "money") {
        opt_obj.render_str = opt_obj.info.a_money;
        opt_obj.render_str = (
          <span style={{ color: "blue" }}>
            {strFunc.comma(opt_obj.render_str)}
          </span>
        );
      }
    } else if (key == "row_view_debt_in" && opt_obj.info.a_money_type == "debt") {
      if (opt_obj.info.a_inout == "in") {
        opt_obj.render_str = opt_obj.info.a_money;
        opt_obj.render_str = strFunc.comma(opt_obj.render_str);
      }
    } else if (key == "row_view_money_out") {
      if (opt_obj.info.a_inout == "out" && opt_obj.info.a_money_type == "money") {
        opt_obj.render_str = opt_obj.info.a_money;
        opt_obj.render_str = (
          <span style={{ color: "red" }}>
            {strFunc.comma(opt_obj.render_str)}
          </span>
        );
      }
    }
    
    return opt_obj.render_str;
  };

  return (
    <div>
      <ListSimpleArea
        xColumnArr={xColumnArr}
        infoArr={infoArr}
        setInfoArr={myProps.setInfoArr}
        select_row_num_arr={select_row_num_arr}
        set_select_row_num_arr={myProps.set_select_row_num_arr}
        is_select_click_multy={false}
        is_grid={false}
        get_td_render_tag={get_td_render_tag}
        table_style={{ width: "auto", margin: "0 auto" }}
      ></ListSimpleArea>
    </div>
  );
};
export default ListArea;